const prefix = 'pra-chamados';

export const cookies = {
  AUTH_TOKEN: `${prefix}.token`,
};
